// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"ForSorting_checkbox__nDsIz","checkedCheckbox":"ForSorting_checkedCheckbox__1njgN","sortingBox":"ForSorting_sortingBox__1r9en"};